import React, { useState } from "react";
import moment from "moment";
import "./style.css";

const ForwardedDocs = () => {
  const [time, setTime] = useState("");
  setInterval(() => {
    setTime(moment().format("MMMM Do YYYY, h:mm:ss a"));
  }, 1000);

  return (
    <div>
      <div className="title_section">
        <div>
          <h4 className="title">IT Unit</h4>
          <p className="inner_title">Forwarded Documents</p>
        </div>
        <div>
          <ul>
            <li className="nav_items">
              <i className="fas fa-home-alt"></i>Home
            </li>
            <li className="nav_items">{">"}</li>
            <li className="nav_items">Dashboard</li>
            <li className="nav_items">{">"}</li>
            <li className="nav_items">{time}</li>
          </ul>
        </div>
      </div>
      <div className="table-wrapper">
        <p className="title">Documents Forwarded</p>
        <div className="action_form">
          <div className="show">
            <p>Show</p>
            <select>
              <option>10</option>
              <option>20</option>
              <option>30</option>
              <option>40</option>
            </select>
            <p>entries</p>
          </div>
          <div className="search">
            <p>Search:</p>
            <input type="text" />
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <table>
          <tr>
            <th>Tracking</th>
            <th>Type & Description</th>
            <th>Action Needed</th>
            <th>Date & Time Forwarded</th>
            <th>Accepted</th>
          </tr>
          <tr>
            <td>
              <a style={{ textDecoration: "none" }} href="http://">
                22-1185
              </a>
            </td>
            <td>
              <div>
                <p>Communications(Letters,Etc.)</p>
                <p>Hello this is from cheso</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
                <p>From: Administrator</p>
              </div>
            </td>
            <td>
              <p>for payments</p>
            </td>
            <td>
              <p>06/29/22 @ 1:01PM</p>
              <p>To: Prasasan(head office){">>"}Sujan Upereti</p>
            </td>

            <td>
              <div>
                <button className="edit_btn">Edit Route</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <a style={{ textDecoration: "none" }} href="http://">
                22-1185
              </a>
            </td>
            <td>
              <div>
                <p>Communications(Letters,Etc.)</p>
                <p>Hello this is from cheso</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
                <p>From: Administrator</p>
              </div>
            </td>
            <td>
              <p>to discuss about the budget.</p>
            </td>
            <td>
              <p>06/23/22 @ 11:22 PM</p>
              <p>To: Store</p>
            </td>
            <td>
              <div>
                <p>06/23/22 @ 11:30 PM</p>
                <p>Action Taken: i have checked it this is okay from my end.</p>
                <p>Forwarded to Prasasan(head office){">>"}Sujan Upereti.</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div className="table_footer">
        <div>
          <p>Showing 1 to 1 of 1 entries</p>
        </div>
        <div>
          <button className="padding:6px">Previous</button>
          <button
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              padding: "8px",
            }}
          >
            1
          </button>
          <button className="padding:6px">Next</button>
        </div>
      </div>
    </div>
  );
};

export default ForwardedDocs;
